<template>
    <div>
        <rkm-row>

            <rkm-col cols="12">
                <rkm-area
                    title="Tipo de visita"
                    no-margin-top
                    type="fieldset"
                >

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                v-model="data.model.motivo.tipoVisita"
                                name="Tipo de visita"
                                :validations="{ required: isVisitaRealizada() }"
                            >
                                <rkm-form-checkbox
                                    v-for="tipo in data.form.tipoVisita"
                                    :key="tipo.id"
                                    :value="tipo.id"
                                    :disabled="isDisabledMotivo() || isDisabledTipoVisita(tipo.id)"
                                    class="w-25 m-0"
                                >
                                    {{ tipo.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Busca ativa"
                    no-margin-top
                    type="fieldset"
                >

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                v-model="data.model.motivo.buscaAtiva"
                                :validations="{ required: isVisitaRealizada() }"
                                name="Busca ativa"
                            >
                                <rkm-form-checkbox
                                    v-for="busca in data.form.buscaAtiva"
                                    :key="busca.id"
                                    :value="busca.id"
                                    :disabled="isDisabledMotivo() || isDisabledTipoImovel()"
                                    class="w-25 m-0"
                                >
                                    {{ busca.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Controle ambiental/Vetorial"
                    no-margin-top
                    type="fieldset"
                >

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                v-model="data.model.motivo.controleAmbientalVetorial"
                                :validations="{ required: isVisitaRealizada() }"
                                name="Controle ambiental/Vetorial"
                            >
                                <rkm-form-checkbox
                                    v-for="controle in data.form.controleAmbientalVetorial"
                                    :key="controle.id"
                                    :value="controle.id"
                                    :disabled="isDisabledMotivo()"
                                    class="w-25 m-0"
                                >
                                    {{ controle.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Acompanhamento"
                    type="fieldset"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                v-model="data.model.motivo.acompanhamento"
                                :validations="{ required: isVisitaRealizada() }"
                                name="Acompanhamento"
                            >
                                <rkm-form-checkbox
                                    v-for="acompanhamento in data.form.acompanhamento"
                                    :key="acompanhamento.id"
                                    :value="acompanhamento.id"
                                    class="w-25 m-0"
                                    :disabled="isDisabledMotivo(acompanhamento.id) || isDisabledTipoImovel()"
                                >
                                    {{ acompanhamento.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Outros"
                    no-margin-top
                    type="fieldset"
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                v-model="data.model.motivo.outroMotivo"
                                :validations="{ required: isVisitaRealizada() }"
                                name="Outros"
                            >
                                <rkm-form-checkbox
                                    v-for="outro in data.form.outrosMotivos"
                                    :key="outro.id"
                                    :value="outro.id"
                                    :disabled="isDisabledMotivo() || isDisabledOutroMotivo(outro.id)"
                                    class="w-25 m-0"
                                >
                                    {{ outro.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>

// Mixins
import { repository, object, formats, mask, data } from '@/mixins'

//Enums
import desfecho from '@/enums/atencao-basica/visita-domiciliar/desfecho'
import tipoImovel from '@/enums/atencao-basica/cadastro-domiciliar/tipoImovel'
import tipoVisita from '@/enums/atencao-basica/visita-domiciliar/tipoVisita'
import outrosMotivo from '@/enums/atencao-basica/visita-domiciliar/outrosMotivo'
import acompanhamento from '@/enums/atencao-basica/visita-domiciliar/acompanhamento'
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    computed: {
        validations() {

            return {
                turno: { required: true },
            }
        },
    },
    data: () => ({
        enums: {
            desfecho,
            tipoImovel,
            tipoVisita,
            outrosMotivo,
            acompanhamento,
            sexo,
        },
    }),
    methods: {
        isDisabledMotivo(motivoId) {

            return this.data.model.atendimento.desfechoId == this.enums.desfecho.VISITA_RECUSADA
                || this.data.model.atendimento.desfechoId == this.enums.desfecho.AUSENTE
                || motivoId == this.enums.acompanhamento.GESTANTE
                    && this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO
                || motivoId == this.enums.acompanhamento.PUERPERA
                    && this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO
        },
        isVisitaRealizada() {
            const desfechoId = this.data.model.atendimento?.desfechoId

            if (desfechoId !== this.enums.desfecho.VISITA_REALIZADA) return false

            const motivo = this.data.model.motivo

            const motivosPreenchidos = ![
                motivo.tipoVisita,
                motivo.buscaAtiva,
                motivo.controleAmbientalVetorial,
                motivo.acompanhamento,
                motivo.outroMotivo
            ].some(arr => Array.isArray(arr) && arr.length > 0)

            return motivosPreenchidos
        },
        isDisabledTipoImovel() {

            return this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.COMERCIO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.TERRENO_BALDIO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.PONTO_ESTRATEGICO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.ESCOLA
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.CRECHE
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.ESTABELECIMENTO_RELIGIOSO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.CASAI
        },
        isDisabledTipoVisita(value) {

            return value == this.enums.tipoVisita.VISITA_PERIODICA && this.isDisabledTipoImovel()
        },
        isDisabledOutroMotivo(value) {

            return value == this.enums.outrosMotivo.EGRESSO_DE_INTERNACAO && this.isDisabledTipoImovel()
        },
    },
    mixins: [ repository, object, formats, mask, data ],
    props: {
        data: { type: Object, required: false },
    },
}
</script>